import { Breadcrumb, Card, Checkbox, message, Tag } from 'antd';
import { ColumnsType } from 'antd/es/table';
import { Button, Table } from 'components';
import { UserApiService } from 'features/users/api/user-api.service';
import { AddAppUserModal } from 'features/users/components/modals/add-app-user-modal';
import { AddsatationuserMappingModal } from 'features/users/components/modals/add-station-mapping';
import { ChangePasswordModal } from 'features/users/components/modals/change-password-modal';
import { actions, PermissionRow, SaveUserPermissionsDTO, UsersTopBarProps } from 'features/users/types';
import {
  useGetUser,
  useGetUserRolePermissions,
  useSaveUserRolePermissions
} from 'features/users/use-cases';
import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { ROUTES, SideBarMenus } from 'routes/constants';
import { HasPermission } from 'utils/CheckPermissions';


export const AdminDetailTopBar = ({
  id
}: UsersTopBarProps) => {
  const [data, setData] = useState<PermissionRow[]>([]);
  const [expandedKeys, setExpandedKeys] = useState<string[]>([]);
  const userRolePermissionsResult = useGetUserRolePermissions(id, {
    cacheTime: 0,
  });
  const [modal, SetModal] = useState(false)
  const userQueryResult = useGetUser(id, {
    cacheTime: 0,
  });

  const { mutate: saveUserRolePermissions } = useSaveUserRolePermissions();
  const [usermaping, setUserMapping] = useState<any>('')
  const { data: userData } = userQueryResult;
  //For Edit

   const [showAppUserDetailModal, setShowAppUserDetailModal] = useState(false);
   const [userDetailEditData, setUserDetailEditData] = useState<any>(undefined);
   const [showChangePasswordModal, setShowChangePasswordModal] = useState(false);
    
        

  const { data: userRolePermissions } = userRolePermissionsResult;
  useEffect(() => {
    if (userRolePermissions != undefined) {
      setData(userRolePermissions);
      const defaultExpanded = userRolePermissions
        .filter((row) => userRolePermissions.some((r) => r.parentKey === row.key)).map((row) => row.key);

      setExpandedKeys(defaultExpanded);
    }
  }, [userRolePermissions]);
  const getChildren = (parentKey: string) => data.filter((item) => item.parentKey === parentKey);
  const revokeAllPermissions = () => {
    if (userRolePermissions != undefined) {
      const updated = userRolePermissions.map(row => ({
        ...row,
        permissions: Object.fromEntries(
          Object.keys(row.permissions).map(key => [key, false])
        )
      }));
      setData(updated);

      const saveURolePayload: SaveUserPermissionsDTO = {
        userId: id,
        rolePermission: updated
      };
      saveUserRolePermissions(saveURolePayload);
    }

  };


  const handleGrantAll = () => {
    if (userRolePermissions != undefined) {
      const updated = userRolePermissions.map(row => ({
        ...row,
        permissions: Object.fromEntries(
          Object.keys(row.permissions).map(key => [key, true])
        )
      }));
      setData(updated);

      const saveURolePayload: SaveUserPermissionsDTO = {
        userId: id,
        rolePermission: updated
      };
      saveUserRolePermissions(saveURolePayload);
    }

  };

  const handleCheckboxChange = (recordKey: string, actionKey: string, checked: boolean) => {
    setData((prev) =>
      prev.map((row) => {
        if (row.key === recordKey) {
          const updatedPermissions = {
            ...row.permissions,
            [actionKey]: checked,
          };

          if (
            checked &&
            ['add', 'edit', 'delete', 'print'].includes(actionKey.toLowerCase())
          ) {
            updatedPermissions['view'] = true;
          }

          return {
            ...row,
            permissions: updatedPermissions,
          };
        }

        // Apply same logic to children if this row is a parent
        if (row.parentKey === recordKey) {
          const updatedPermissions = {
            ...row.permissions,
            [actionKey]: checked,
          };

          if (
            checked &&
            ['add', 'edit', 'delete', 'print'].includes(actionKey.toLowerCase())
          ) {
            updatedPermissions['view'] = true;
          }

          return {
            ...row,
            permissions: updatedPermissions,
          };
        }

        return row;
      })
    );
  };



  const handleSelectAllColumn = (actionKey: string, checked: boolean) => {
    setData((prev) =>
      prev.map((row) => ({
        ...row,
        permissions: { ...row.permissions, [actionKey]: checked },
      }))
    );
  };
  const handleSubmit = () => {
    const formatted = data.map((row) => ({
      key: row.key,
      permissions: row.permissions,
    }));
    const saveURolePayload: SaveUserPermissionsDTO = {
      userId: id,
      rolePermission: formatted
    };
    saveUserRolePermissions(saveURolePayload);
  };
  const flatRows = data.flatMap((row) => {
    if (!row.parentKey) {
      const children = expandedKeys.includes(row.key) ? getChildren(row.key) : [];

      return [row, ...children];
    }

    return row.parentKey ? [] : [row];
  });
  const columns: ColumnsType<PermissionRow> = [
    {
      title: 'Pages',
      dataIndex: 'title',
      key: 'title',
      render: (_: any, record: PermissionRow) => {
        const hasChildren = data.some((r) => r.parentKey === record.key);
        const isExpanded = expandedKeys.includes(record.key);

        return (
          <div style={{ display: 'flex', alignItems: 'center', paddingLeft: record.parentKey ? 24 : 0 }}>
            {hasChildren && !record.parentKey && (
              <span
                onClick={() =>
                  setExpandedKeys((prev) =>
                    prev.includes(record.key)
                      ? prev.filter((k) => k !== record.key)
                      : [...prev, record.key]
                  )
                }
                style={{ cursor: 'pointer', marginRight: 8 }}
              >
                {isExpanded ? '➖' : '➕'}
              </span>
            )}
            {record.title}
          </div>
        );
      },
    },
    ...actions.map(({ key, label }) => ({
      title: (
        <Checkbox
          onChange={(e) => handleSelectAllColumn(key, e.target.checked)}
          indeterminate={
            data.some((row) => row.permissions[key]) &&
            !data.every((row) => row.permissions[key])
          }
          checked={data.every((row) => row.permissions[key])}
        >
          {label}
        </Checkbox>
      ),
      key,
      dataIndex: key,
      align: 'center' as const,
      render: (_: any, record: PermissionRow) => {
        const children = getChildren(record.key);
        const isParent = children.length > 0;

        let checked = record.permissions[key];
        let indeterminate = false;

        if (isParent) {
          const all = children.every((child) => child.permissions[key]);
          const some = children.some((child) => child.permissions[key]);
          checked = all;
          indeterminate = some && !all;
        }

        return (
          <Checkbox
            checked={checked}
            indeterminate={indeterminate}
            onChange={(e) => handleCheckboxChange(record.key, key, e.target.checked)}
          />
        );
      },
    })),
  ];
  // const columnsMap = [
  //   {
  //     title: 'Station Title',
  //     dataIndex: 'stationTitle',
  //     key: 'stationTitle',
  //   },
  // ];
  const getUserMapping = async () => {
    try {
      const resp: any = await UserApiService().getUserMapping(id as any)
      setUserMapping(resp?.res)
    } catch (error: any) {
      message.error(error)
    }
  }
  useEffect(() => {
    getUserMapping();
    
    }, [])

     

  
  //  const removeStation = (id: number) => {
  //   alert('hello'+id)
    
  // };
      const handleOpenModal = () => { 

      setUserDetailEditData({
            userId:userData?.userId ,
            role:userData?.role ,
            name:userData?.name ,
            email:userData?.email ,
            phoneNumber:userData?.phoneNumber ,
            isActive:userData?.isActive
          });
     setShowAppUserDetailModal(true);

  }

    const handleCloseModal = () => {
    setShowAppUserDetailModal(false);
    document.body.style.overflow = 'visible';
  }

     const handleOpenChangePasswordModal = () =>{         
          setShowChangePasswordModal(true);              
   }

      const handleChangePCloseModal = () => {   
    setShowChangePasswordModal(false);
  }


  return (
    <>
    <div className={`cstmrightmdl ${showAppUserDetailModal && "show"}`}>
            <AddAppUserModal onClose={handleCloseModal} userEditData={userDetailEditData} />
    </div>

     {showChangePasswordModal ? (<div className={`cstmrightmdl ${showChangePasswordModal && "show"}`}>
            <ChangePasswordModal onClose={handleChangePCloseModal} updateUserId={userData?.userId} />
          </div>) : ''}


      <Breadcrumb separator=">" style={{ marginBottom: 10 }}>
        <Breadcrumb.Item>
          <Link to={ROUTES.USERS_APP}>User Management</Link>
        </Breadcrumb.Item>
        <Breadcrumb.Item>
          <Link to={ROUTES.USERS_APP}>Admins </Link>
        </Breadcrumb.Item>
        <Breadcrumb.Item>
          Detail
        </Breadcrumb.Item>
      </Breadcrumb>

       
      
      <Card className='prfle_crd' title="My Profile"
      
       extra={
         
         HasPermission(SideBarMenus.ADMIN, 'edit') ? ( 
          <>
          <div style={{ marginTop: '16px' }}>
            <Button type="primary"  style={{ marginRight: 8 }} onClick={() => handleOpenModal()}>Edit User</Button>
             <Button  type="primary" onClick={() => handleOpenChangePasswordModal()}>Change Password</Button>  
          </div>
           
            </>
           ):null
        
           
      }
     
      >
        <div className='profile_data'>
          <div className='user_d'>
            <p>Name : <span>{userData?.name || '-'}</span></p>
            <p>Mobile No : <span>{userData?.phoneNumber || '-'}</span></p>
            <p>Email : <span>{userData?.email || '-'}</span></p>
            <p>Is Active : <span>{userData?.isActive ? 'Active' : 'Inactive'}</span></p>
            <p>Role Type : <span>{userData?.roleType || '-'}</span></p>
            <p>User Name : <span>{userData?.userName || '-'}</span></p>
          </div>
          {/* Show Mapping button conditionally or always */}
          
          <div className={`cstmrightmdl ${modal && "show"}`}>
            <AddsatationuserMappingModal onClose={() => SetModal(false)} getUserMapping={getUserMapping} />
          </div>

        </div>
      </Card>
      <Card className='prfle_crd' title="Station "
       extra={
        <>
        <div style={{ marginTop: '16px' }}>
            <Button type="primary" onClick={() => SetModal(true)}>Station Mapping</Button>
          </div>
        </>
       }
      >
        <>
        {/* <Table
          columns={columnsMap}
          dataSource={usermaping?.rc || []}
          rowKey="stationId"
          pagination={false}
        /> */}
      
       {usermaping?.rc && usermaping.rc.length > 0 && (
          <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8 }}>
            {usermaping.rc.map((station: any) => (
              <Tag
                key={station.stationId}
               // onClose={() => removeStation(station.stationId)}
               // closable  // uncomment if you want "X" icon
               // color="blue"
                style={{
                  padding: '4px 10px',
                  borderRadius: '16px',
                  fontWeight: 500,
                  fontSize: '14px',
                }}
              >
                {station.stationTitle}
              </Tag>
            ))}
          </div>
        )}
    </>
      </Card>
      {/* <div style={{ textAlign: 'right', marginTop: 16 }}></div> */}

      <Card title={'Role : ' + userData?.roleType} className='role_card'
        extra={
          <>
            <Button type="primary" onClick={handleSubmit} style={{ marginLeft: '8px' }}>
              Save Privileges
            </Button>
            <Button type="primary" onClick={handleGrantAll} style={{ marginLeft: '8px' }}>
              Grant All
            </Button>
            <Button type="default" onClick={revokeAllPermissions} style={{ marginLeft: '8px' }}>
              Revoke All
            </Button>
          </>
        }
      >

        <Table
          columns={columns}
          dataSource={flatRows}
          rowKey="key"
          pagination={false}
          bordered
        />

      </Card>

    </>
  );
};


